module.exports = {"allowedBrands":{"MASTERCARD":"mastercard","VISA":"visa","AMEX":"amex","ELO":"elo","ELO_DEBIT":"elo","CB":"cb","DISCOVER":"discover"}}